/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Engagement_Today_StreakInputs */

const en_us2_engagement_today_streak = /** @type {(inputs: Engagement_Today_StreakInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 week in a row. Consistency is what counts most.`);
	return /** @type {LocalizedString} */ (`${i?.weeks} weeks in a row. Consistency is what counts most.`)
	
};

const pt_br2_engagement_today_streak = /** @type {(inputs: Engagement_Today_StreakInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 semana seguida. Constância é o que mais conta.`);
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas seguidas. Constância é o que mais conta.`)
	
};

const es_419_engagement_today_streak = /** @type {(inputs: Engagement_Today_StreakInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 semana seguida. La constancia es lo que más cuenta.`);
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas seguidas. La constancia es lo que más cuenta.`)
	
};

const pt_pt2_engagement_today_streak = /** @type {(inputs: Engagement_Today_StreakInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 semana seguida. A constância é o que mais conta.`);
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas seguidas. A constância é o que mais conta.`)
	
};

const fr_fr2_engagement_today_streak = /** @type {(inputs: Engagement_Today_StreakInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 semaine d'affilée. La régularité, c'est ce qui compte le plus.`);
	return /** @type {LocalizedString} */ (`${i?.weeks} semaines d'affilée. La régularité, c'est ce qui compte le plus.`)
	
};

const de_de2_engagement_today_streak = /** @type {(inputs: Engagement_Today_StreakInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 Woche am Stück. Beständigkeit zählt am meisten.`);
	return /** @type {LocalizedString} */ (`${i?.weeks} Wochen am Stück. Beständigkeit zählt am meisten.`)
	
};

const it_it2_engagement_today_streak = /** @type {(inputs: Engagement_Today_StreakInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 settimana di fila. La costanza è ciò che conta di più.`);
	return /** @type {LocalizedString} */ (`${i?.weeks} settimane di fila. La costanza è ciò che conta di più.`)
	
};

/**
* | weeks | output |
* | --- | --- |
* | "1" | "1 week in a row. Consistency is what counts most." |
* | * | "{weeks} weeks in a row. Consistency is what counts most." |
*
* @param {Engagement_Today_StreakInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_today_streak = /** @type {((inputs: Engagement_Today_StreakInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Today_StreakInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_today_streak(inputs)
	if (locale === "es-419") return es_419_engagement_today_streak(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_today_streak(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_today_streak(inputs)
	if (locale === "de-DE") return de_de2_engagement_today_streak(inputs)
	if (locale === "it-IT") return it_it2_engagement_today_streak(inputs)
	return en_us2_engagement_today_streak(inputs)
});
export { engagement_today_streak as "engagement.today_streak" }